"use strict";

export function initInScope ($scope) {

    $scope.find('.js-toggle-navbar-menu-overlay').on('click', function (e) {
        let $nav = $(this).closest('.navbar');

        if($nav.hasClass('is-open')){
            $nav.removeClass('is-open');
            $('body').removeClass('nav-open');
        }else{
            $nav.addClass('is-open');
            $('body').addClass('nav-open');
        }
    });

}